import React, { useRef, useState, useEffect } from 'react';
import { Table, Badge } from 'reactstrap';
import { FaCalendarCheck, FaClock, FaUserPlus, FaWhmcs, FaArrowDown } from 'react-icons/fa';
import Moment from 'react-moment';
import 'moment/locale/id';
import { useDispatch } from 'react-redux';
import { handleDelete } from 'Component/DashboardQeza/Branch/BranchDetailUtils';
import { deleteSetupSchedule } from 'Services/Features/SetupSchedule/Utils/setupScheduleUtils';
import { useParams } from 'react-router-dom';

const TableCalendarGrid = ({ groupedSchedules }) => {
    const { id } = useParams();
    const user = JSON.parse(localStorage.getItem('USER'));
    const tableRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    const [showScrollIcon, setShowScrollIcon] = useState(false);
    const dispatch = useDispatch();

    // Tentukan branch_id berdasarkan role dan route
    const getBranchId = () => {
        // Jika ada params id (route super admin), gunakan params id
        if (id) {
            return id;
        }
        // Jika tidak ada params id (route admin), ambil dari localStorage
        return user?.branch_id;
    };

    const branchId = getBranchId();

    useEffect(() => {
        const checkScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
            setShowScrollIcon(scrollTop + clientHeight < scrollHeight);
        };

        const table = tableRef.current;
        if (table) {
            table.addEventListener('scroll', checkScroll);
            checkScroll(); // Cek saat pertama kali render
        }

        return () => {
            if (table) {
                table.removeEventListener('scroll', checkScroll);
            }
        };
    }, []);

    return (
        <div className="table-responsive"
            ref={tableRef}
            style={{
                maxHeight: '500px',
                overflowY: 'auto',
                boxShadow: isScrolled ? 'inset 0 5px 5px -5px rgba(0, 0, 0, 0.2)' : 'none',
                borderBottom: isEnd ? 'none' : '2px solid #ccc',
            }}
        >
            <Table className="table-hover table-bordered sticky-header-table">
                <thead className="bg-primary">
                    <tr>
                        <th scope="col" className="" style={{ width: '15px' }}>{'#'}</th>
                        <th scope="col" className="" style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}><FaCalendarCheck />{' Tanggal Jadwal'}</th>
                        <th scope="col" className="text-center"><FaClock />{' Jam'}</th>
                        <th scope="col" style={{ width: '100px' }}><FaUserPlus />{' Kuota'}</th>
                        <th scope="col" className="text-center" style={{ width: 'auto' }} ><FaWhmcs />{' Aksi'}</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(groupedSchedules).length === 0 ? (
                        <tr>
                            <td colSpan="5">
                                <div className="text-center p-4">
                                    <Badge color="danger">Belum ada pengaturan jadwal tersedia!</Badge>
                                </div>
                            </td>
                        </tr>
                    ) : (
                        Object.entries(groupedSchedules).map(([date, items], index) =>
                            items.map((item, i) => (
                                <tr key={item.id}>
                                    {i === 0 && (
                                        <>
                                            <th rowSpan={items.length} className="" scope="row" style={{ verticalAlign: "top" }}>
                                                {index + 1}
                                            </th>
                                            <td rowSpan={items.length} className="">
                                                <Moment format="dddd, DD MMMM YYYY">
                                                    {item.schedule_date}
                                                </Moment>
                                                <br />
                                                <small>
                                                    {'Jadwal akan diterapkan pada'}
                                                    <br />
                                                    <Moment format="dddd, DD MMMM YYYY">
                                                        {item.will_applied_at}
                                                    </Moment>
                                                    {' pukul 00:00 WIB'}
                                                </small>
                                            </td>
                                        </>
                                    )}
                                    <td className="text-center" style={{ maxWidth: 'auto', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                        {item.hour_start_at} - {item.hour_end_at}
                                    </td>
                                    <td className="text-center">{item.quota}</td>
                                    <td>
                                        <div className="d-flex justify-content-center">
                                            {/* <button
                                                title="Edit"
                                                className="btn btn-primary"
                                                style={{ padding: '4px 8px', fontSize: '12px' }}
                                            >
                                                <i className="fa fa-pencil"></i>
                                            </button> */}

                                            <button
                                                title="Hapus"
                                                className="btn btn-danger ms-2"
                                                style={{ padding: '4px 8px', fontSize: '12px' }}
                                                onClick={() => handleDelete(dispatch, branchId, item.id, deleteSetupSchedule)}
                                            >
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )
                    )}
                </tbody>
            </Table>
            {showScrollIcon && (
                <div style={{
                    position: 'absolute',
                    bottom: '10px',
                    right: '90px',
                    backgroundColor: '#FA6400',
                    color: '#fff',
                    borderRadius: '50%',
                    padding: '8px 10px 4px 10px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                    cursor: 'pointer',
                    animation: 'bounce 1.5s infinite'
                }}>
                    <FaArrowDown size={13} />
                </div>
            )}
        </div>
    );
};

export default TableCalendarGrid;
